module.exports = __webpack_public_path__ + "c282e97e351018fdcae6ef0d2b80fa53.gif";